export function imageUrl(path) {
  if (!path) return "";

  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  if (path.startsWith("/storage/")) {
    return path;
  }

  if (path.startsWith("storage/")) {
    return `/${path}`;
  }

  if (path.startsWith("products/")) {
    return `/storage/${path}`;
  }

  if (path.startsWith("/images/")) {
    return path;
  }

  if (path.startsWith("images/")) {
    return `/${path}`;
  }

  if (
    path.endsWith(".jpg") ||
    path.endsWith(".jpeg") ||
    path.endsWith(".png") ||
    path.endsWith(".webp")
  ) {
    return `/storage/products/${path}`;
  }

  return `/images/${path}`;
}
